export const passwordRules = /^(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
